import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealTiersMiniEntity } from '../../domain/entities/MealTiersMiniEntity'
import type { MealTierListedAdminDto } from '@/backend/market'

export class MealTiersMiniModel extends MealTiersMiniEntity {
  constructor(dataDto: MealTierListedAdminDto) {
    super()
    mapEntityProperties<MealTiersMiniEntity>(this, dataDto)
  }
}
